var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientEnv || _vm.nodeEnv)?_c('div',{staticClass:"env-tip"},[_c('span',[_vm._v("页面环境为："+_vm._s(_vm.envMap[_vm.clientEnv] || _vm.envMap[_vm.nodeEnv])+"；node环境为："+_vm._s(_vm.envMap[_vm.nodeEnv] || '正式环境'))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }